import React from 'react';
import styled from 'styled-components/macro';
import { Applicants as ApplicantType } from '../utils/data_types';
import { THEME_COLORS } from '../utils/theme';
import { SectionHeader, Data, DataLabel } from './styles';

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 30px 0;
`;

const ApplicantData = styled.div`
  text-align: center;
  margin: 30px 7vw;
`;

interface Props {
  applicantData: ApplicantType;
}

export const Applicants: React.FC<Props> = props => {
  return (
    <>
      <SectionHeader color={THEME_COLORS.lightGrey}>Applicants</SectionHeader>
      <Container>
        <ApplicantData>
          <Data>{props.applicantData.numApplicants ?? '-'}</Data>
          <DataLabel>Total Applications</DataLabel>
        </ApplicantData>
        <ApplicantData>
          <Data>{props.applicantData.acceptanceRate ?? '-'}%</Data>
          <DataLabel>Total Acceptance Rate</DataLabel>
        </ApplicantData>
      </Container>
    </>
  );
};
